import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  EventEmitter,
  Output,
} from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { UploadMaterialMetadataModel } from '../../models/document-metadata.model';
import { JscHearingRequestDocumentModel } from '../../models/jsc-hearing-request-document.model';
@Component({
  selector: 'jsc-hearing-request-documents-view',
  templateUrl: './jsc-hearing-request-documents-view.component.html',
  styleUrls: ['./jsc-hearing-request-documents-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JscHearingRequestDocumentsViewComponent implements OnInit {
  @Input() displayedColumns: string[];
  @Input() set hearingRequestDocuments(
    value: JscHearingRequestDocumentModel[]
  ) {
    this._hearingRequestDocuments = value;
    this.dataSource = new MatTableDataSource(value || []);
  }
  get hearingRequestDocuments(): JscHearingRequestDocumentModel[] {
    return this._hearingRequestDocuments;
  }
  public dataSource: MatTableDataSource<JscHearingRequestDocumentModel>;

  @Output() openFile = new EventEmitter<UploadMaterialMetadataModel>();

  private _hearingRequestDocuments: JscHearingRequestDocumentModel[];
  constructor() {}

  ngOnInit(): void {}

  public onOpenFile = (docToOpen: JscHearingRequestDocumentModel) => {
    this.openFile.emit(docToOpen.document);
  };
}
